import React from "react";
import { View, StyleSheet, TouchableOpacity } from "react-native";
// import Button from "@components/Button";
import Text from "@components/AppText";
import Coupon from "@assets/svg/Coupon";
// import CloseCircle from "@assets/svg/CloseCircle";
import CloseWithShadow from "@assets/svg/CloseWithShadow";
import Caret from "@assets/svg/Caret";
import analytics from "@services/analytics";
import { COUPON_FLOW_EVENTS } from "../../constants/analyticsEventsCT";
import metrics from "@constants/metrics";

const DiscountView = ({
  // applyCouponCode,
  removeCouponCode,
  appliedCouponCode,
  // notApplicableMessage,
  // couponAppliedMessage,
  isCouponValid,
  navigation,
  cartTotal,
  currentCartSkuIds,
  text,
}) => {
  return (
    <View>
      {appliedCouponCode ? (
        <View
          style={[
            styles.beLikeRow,
            {
              justifyContent: "space-between",
              padding: 10,
              borderTopColor: "rgba(0,0,0,0.1)",
              borderTopWidth: 1,
              borderBottomColor: "rgba(0,0,0,0.1)",
              borderBottomWidth: 1,
              backgroundColor: isCouponValid
                ? "rgba(0, 221, 115, 0.1)"
                : "rgba(255, 46, 0, 0.1)",
            },
          ]}
        >
          <View>
            <Text bold>{appliedCouponCode}</Text>
            <Text
              style={{
                color: isCouponValid ? "#00AB59" : "#FF2E00",
              }}
            >
              {text}
            </Text>
          </View>
          <TouchableOpacity onPress={removeCouponCode}>
            <CloseWithShadow />
          </TouchableOpacity>
        </View>
      ) : (
        <TouchableOpacity
          style={[styles.beLikeRow, styles.couponBtn]}
          onPress={() => {
            analytics.trackEvent(COUPON_FLOW_EVENTS.APPLY_COUPON, {
              cart_value: cartTotal,
              ...currentCartSkuIds,
            });
            navigation.navigate("CouponScreen", {
              cart_value: cartTotal,
              ...currentCartSkuIds,
            });
          }}
        >
          <View style={[styles.beLikeRow]}>
            <View>
              <Coupon />
            </View>
            <View style={{ paddingHorizontal: 10 }}>
              <Text bold fontType="head3">
                {text}
              </Text>
            </View>
          </View>
          <View>
            <Caret strokeColor="#E40046" height={24} width={24} />
          </View>
        </TouchableOpacity>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  beLikeRow: {
    alignItems: "center",
    flexDirection: "row",
    // width: "100%"
  },
  couponBtn: {
    backgroundColor: "#fff",
    justifyContent: "space-between",
    borderTopColor: "#ddd",
    borderTopWidth: 1,
    borderBottomColor: "#ddd",
    borderBottomWidth: 1,
    padding: 20,
    paddingHorizontal: metrics.baseGutter,
    paddingRight: 20,
  },
});

export default DiscountView;
